import { GET } from "./api";

export const ReadDashboardHome = async (locale, portal) => {
    const query = new URLSearchParams();
    if (locale) query.set('locale', locale);
    if (portal === 'essentials' || portal === 'accelerator') query.set('portal', portal);
    return GET(`/dashboard-home${query.toString() ? `?${query}` : ''}`, true);
};
